import { render, staticRenderFns } from "./_ToDelivered.vue?vue&type=template&id=2c30b53d"
import script from "./_ToDelivered.vue?vue&type=script&lang=js"
export * from "./_ToDelivered.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports